export default __webpack_public_path__ + "static/media/1988-1.45bc75e8.png";